import React, { useState, useRef } from "react";

const TooltipExcelsheet = ({ cell, errorDetails, errorClasses }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [tooltipStyle, setTooltipStyle] = useState({});
  const cellRef = useRef(null);

  const handleMouseEnter = () => {
    if (!cell.className) return;
    const baseClass = cell.className.split(" ")[0];
    if (baseClass === errorClasses[0]) {
      setErrorMessage(errorDetails?.err1 || "");
    } else if (baseClass === errorClasses[1]) {
      setErrorMessage(errorDetails?.err2 || "");
    }

    if (cellRef.current) {
      const rect = cellRef.current.getBoundingClientRect();
      const TOOLTIP_MAX_WIDTH = 260;
     setTooltipStyle({
        position: "fixed",
        top: rect.bottom + 5,
        left: Math.max(8, Math.min(rect.left, window.innerWidth - TOOLTIP_MAX_WIDTH - 16)),
        maxWidth: `${TOOLTIP_MAX_WIDTH}px`,
        background: "#fcb9b9",
        color: "#ab0505",
        padding: "4px 12px",
        fontSize: "12px",
        borderRadius: "4px",
        zIndex: 1000,
        whiteSpace: "normal",
        wordBreak: "break-word",
        fontWeight:'bold',
        pointerEvents: "none",
        minHeight: "2.2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }
      );
    }

    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
    setErrorMessage("");
  };

  return (
    <>
     {cell && <span
        ref={cellRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          pointerEvents: "auto",
        }}
      >
        {cell.value === "" ? "\u00A0" : cell.value}
      </span>}
      {showTooltip && errorMessage && (
        <div style={tooltipStyle}>{errorMessage}</div>
      )}

    </>
  );
};

export default TooltipExcelsheet;
